//
// Generated class InventoryNoteLine
//

/// <reference path="InventoryNoteLine_ManagedObject.ts" />

class InventoryNoteLine extends InventoryNoteLine_ManagedObject
{
}
